var bighouse = bighouse || {};

bighouse.addressfinder = (function () {
    //Set if postcode is valid before searching. This prevents the user from searching the same postcode multiple times 
    let lastPostcode = '';
  
    //buttons 
    const findBtn = $('.js-findAddress')[0];

  
    //elements
    //postcode 
    const postcodeField = document.getElementById("booking-postcode");
    const postcodeFieldValidationText = $('.js-postcodeError')[0];
    
    //getAddress key
    const getAddressKey = document.getElementById("getAddressKey");
  
    //address dropdown list
    const addressSelectionList = document.getElementById("booking-addressdropdown"); //js-addressDropdown

    //Address finder error message text
    const addressFinderErrorText = $('.js-addressError')[0];
  
    //Address fields
    const addressCity = document.getElementById("booking-city");
    const addressCounty = document.getElementById("booking-county");
    const addressLineOne = document.getElementById("booking-address");
    const addressLineTwo = document.getElementById("booking-address2");

    function init() {
        bindEvents();
    }

    //Events 
    
    //Click - Find 
    function bindEvents() {
      if(findBtn != null)
        findBtn.addEventListener("click", onFind, false);

      $('.js-findAddress').on('click', onFind);
      
      
      if(addressSelectionList != null)
        addressSelectionList.addEventListener("change", function(e) { updateUsersAddress(e); } , false);
    }

  
    function onFind(e) {
      e.preventDefault();

      const postcode = postcodeField.value;

      if(!validatePostcode(postcode))
        return togglePostcodeValidation(true);
      
      if(postcode != lastPostcode) {       
        lastPostcode = postcode;
        clearAddressDropDown();
        togglePostcodeValidation(false);
        toggleFindRequestInternalServerError(false);
        find(postcode, populateAddressesDropDown);
      }
    }


    //Services 

    //Fetch: GET 
    //Get Address 
    function find(postcode, callback) {
      //Fake the call for testing 

      if( document.location.host.indexOf('localhost') !== -1  ){
        callback({"latitude":51.4419059753418,"longitude":-2.6105725765228271,"addresses":["1 Exeter Road, , , , Southville, Bristol, Avon","11 Exeter Road, Southville, , , Southville, Bristol, Avon"]}); 
      } else {
        //HTTP request 
        $.ajax({
            type: 'GET',
            url: `https://api.getAddress.io/find/${postcode}?api-key=${getAddressKey.value}`,
            contentType: "application/json; charset=utf-8",
            error: function(err) {
              toggleFindRequestInternalServerError(true);
            },
            success: function(data) {
              callback(data);
            }
        });
      }

    }

    //Error Handling

    //Validation 
    function validatePostcode(postcode) {
      const regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
      return regex.test(postcode);
    }

    //Error Toggling 
    function togglePostcodeValidation(state) {
      if(state) return show(postcodeFieldValidationText);
      if(!state) return hide(postcodeFieldValidationText);
    }

    function toggleFindRequestInternalServerError(state) {
      if(state) return show(addressFinderErrorText);
      if(!state) return hide(addressFinderErrorText);
    }

    //Utilities 
    
    //Populate dropdown with address results 
    function populateAddressesDropDown(addressList) {
      if(typeof addressList.addresses == 'undefined')
        return toggleFindRequestInternalServerError(true);
        
      addressList.addresses.forEach(function (address) {
        var addressObject = mapAddressToObject(address);
        let option = document.createElement("option");
        option.text = addressObject.Line1;
        option.dataset.Line1 = addressObject.Line1;
        option.dataset.Line2 = addressObject.Line2;
        option.dataset.Locality = addressObject.Locality;
        option.dataset.City = addressObject.City;
        option.dataset.County = addressObject.County;
        addressSelectionList.add(option);
      });
      toggleAddressSelectionList(true);
    }
  
    //Unpopulate dropdown
    function clearAddressDropDown() {
        addressSelectionList.innerHTML = "<option selected disabled hidden>Select your address</option>";
    }
  
    //Update address fields with returned address 
    function updateUsersAddress(e) {
      let selected = e.target.selectedOptions[0];
      addressLineOne.value = addressSelectionList.value;
      addressLineTwo.value = selected.dataset.Line2;
      addressCity.value = selected.dataset.City;
      addressCounty.value = selected.dataset.County;  
    }

  
    //Toggle address dropdown list
    function toggleAddressSelectionList(state) {
      if(state) 
        show( $('.js-addressDropdownRow')[0] )
      if(!state) 
        hide( $('.js-addressDropdownRow')[0] )
    }
      
    function show(element) {
      element.classList.remove('u-hide')
    }
      
    function hide(element) {
      element.classList.add('u-hide')
    }

    //Mapping 
    //Map address json response from getAddress to json object
    function mapAddressToObject(json) {
      var values = json.split(',');
      var address = {
        'Line1': values[0].trim(),
        'Line2': values[1].trim(),
        'Line3': values[2].trim(),
        'Line4': values[3].trim(),
        'Locality': values[4].trim(),
        'City': values[5].trim(),
        'County': values[6].trim()
      };
      return address;
    }
  
    return {
        init: init
    };
})();